import AttachmentUrlConverter from "./AttachmentUrlConverter";
import ThumbnailFarm from "./ThumbnailFarm";

export const ImageOldPattern = new RegExp(/\[##_(\d\D|Image)\|([^|]+)\|([^|]*)\|([^|]*?)_##\]/mgi)
export const ImageNewPattern = new RegExp(/\[##_(\d\D|Image)\|([^|]+)\|([^|]*)\|([^|]*)\|([^|]*?)_##\]/mgi)
export const ImagePatternVersion3 = new RegExp(/\[##_(\d\D|Image)\|([^|]+)\|([^|]*)\|([^|]*)\|([^|]*)\|([^|]*)\|([^|]*?)_##\]/mgi)

class ImageConverter {

  static toHtml(content) {
    if (ImageOldPattern.test(content)) {
      content = content.replace(ImageOldPattern, (match, type, key, attributes, caption) => {
        if (type !== 'Image' && !AttachmentUrlConverter.isUfImage(key)) {
          return match;
        }

        return `<figure data-ke-type="image" data-ke-style="alignCenter" ${attributes}><img src="${AttachmentUrlConverter.toUrl(key)}" ${attributes}/><figcaption>${caption}</figcaption></figure>`;
      })
    }

    if (ImageNewPattern.test(content)) {
      content = content.replace(ImageNewPattern, (match, type, key, style, attributes, caption) => {
        if (type !== 'Image' && !AttachmentUrlConverter.isUfImage(key)) {
          return match;
        }

        if (!style || style === 'undefined') {
          style = "alignCenter";
        }

        return `<figure data-ke-type="image" data-ke-style="${style}" ${attributes}><img src="${AttachmentUrlConverter.toUrl(key)}" ${attributes}/><figcaption>${caption}</figcaption></figure>`;
      })
    }

    if (ImagePatternVersion3.test(content)) {
      content = content.replace(ImagePatternVersion3, (match, type, key, style, attributes, caption, link, linkTarget) => {
        if (type !== 'Image' && !AttachmentUrlConverter.isUfImage(key)) {
          return match;
        }

        if (!style || style === 'undefined') {
          style = "alignCenter";
        }

        if (link) {
          linkTarget = linkTarget || '_blank';
          return `<figure data-ke-type="image" data-ke-style="${style}" data-link="${link}" data-link-newwindow="${linkTarget}" ${attributes}>
<a href="${link}" target="${linkTarget}"><img src="${AttachmentUrlConverter.toUrl(key)}" ${attributes}/></a>
<figcaption>${caption}</figcaption>
</figure>`;
        }

        return `<figure data-ke-type="image" data-ke-style="${style}" ${attributes}><img src="${AttachmentUrlConverter.toUrl(key)}" ${attributes}/><figcaption>${caption}</figcaption></figure>`;
      })
    }

    return content
  }

  static toTistory(editor, e) {
    const $ = editor.dom.$;
    $('[data-ke-type="image"]', e.node).each((idx, elm) => {
      const $elm = $(elm);
      const imageElm = $elm.find('img')[0];

      if (!imageElm) {
        return
      }

      const imageStyle = $elm.attr('data-ke-style') || 'alignCenter';
      const imageMobileStyle = $elm.attr('data-ke-mobilestyle') || $elm.attr('data-ke-mobileStyle') || 'widthContent';

      const imageUrl = AttachmentUrlConverter.toTistory(ThumbnailFarm.from(imageElm.src));
      const imageAttributes = Array.prototype.slice.call(imageElm.attributes)
        .filter(attr => attr.name !== 'src'
          && attr.name.indexOf('data-mce') !== 0
          && attr.name.indexOf('data-mce') !== 0
          && attr.name.indexOf('data-ke-mobilestyle') !== 0)
        .map(attr => `${attr.name}="${attr.value}"`)

      imageAttributes.push(`data-ke-mobilestyle="${imageMobileStyle}"`);

      const linkAttribute = $elm.attr('data-link') || '';
      const linkTarget = $elm.attr('data-link-newwindow') || '';

      const caption = $elm.find('figcaption').text().replace("|", "");

      elm.parentNode.replaceChild(editor.getDoc().createTextNode(`[##_Image|${imageUrl}|${imageStyle}|${imageAttributes.join(' ')}|${caption}|${linkAttribute}|${linkTarget}_##]`), elm)
    })
  }
}

export default ImageConverter
